import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { EntregasAnaliseService } from "../services/entregas-analise.service";


@Injectable({
  providedIn: 'root'
})
export class EntregasAnaliseResolver implements Resolve<boolean> {

  constructor(private service: EntregasAnaliseService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class EntregasAnaliseListResolver implements Resolve<boolean> {

  constructor(private service: EntregasAnaliseService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByListForm();
  }
}